'use strict';

var $ = require('jquery');

$(function() {
	var categories = $('.favorite-categories .categories .category'),
		counter =  $('.fav-count .count'),
		categoryWrapper = $('.favorite-categories .categories');
	var loading = false;
	categories.each(function() {
		$(this).click(function() {
			if (loading) {
				return;
			}
			loading = true;
			$(categoryWrapper).addClass('loading');
			
			var activate = 1;
			if ($(this).hasClass('active')) {
				// remove from active
				activate = 0;
			}

			var that = this;

			$.ajax({
				type: 'POST',
				url: urls.adminAjax,
				data: {
					'operation': activate,
					'cat_id': $(this).data('cat'),
					'action': 'favourite_category',
				},
				dataType: 'json',
				xhrFields: {
					withCredentials: true,
				},
				complete: function(a, b){
					$(that).toggleClass('active');
					counter.text(categoryWrapper.find('.active').length);
				}
			})
			.then(function() {
				$(categoryWrapper).removeClass('loading');
				loading = false;
			});
		})
	}); 
});